import { Box, keyframes } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

// Enhanced animation with more dynamic movement
const bounce = keyframes`
  0% {
    opacity: 0.3;
    transform: translateY(0) scale(0.8);
  }
  20% {
    opacity: 1;
    transform: translateY(-4px) scale(1.1);
  }
  40% {
    opacity: 0.6;
    transform: translateY(0) scale(1);
  }
  60% {
    opacity: 1;
    transform: translateY(-2px) scale(1);
  }
  80% {
    opacity: 0.6;
    transform: translateY(0) scale(0.9);
  }
  100% {
    opacity: 0.3;
    transform: translateY(0) scale(0.8);
  }
`;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1),
  gap: theme.spacing(0.8),
  minWidth: "50px",
  justifyContent: "center",
  margin: "0 auto",
}));

const Dot = styled(Box)<{ delay: string }>(({ theme, delay }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: theme.palette.grey[700],
  opacity: 0.7,
  animation: `${bounce} 1.3s infinite ease-in-out`,
  animationDelay: delay,
  transition: theme.transitions.create(["transform", "opacity"], {
    duration: theme.transitions.duration.shorter,
  }),
  filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.1))",
}));

interface TypingIndicatorProps {
  color?: string;
  size?: "small" | "medium" | "large";
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  color,
  size = "medium",
}) => {
  const dotSize = {
    small: 5,
    medium: 8,
    large: 10,
  }[size];

  return (
    <Container>
      <Dot
        delay="0s"
        sx={{
          backgroundColor: color || "currentColor",
          width: dotSize,
          height: dotSize,
        }}
      />
      <Dot
        delay="0.15s"
        sx={{
          backgroundColor: color || "currentColor",
          width: dotSize,
          height: dotSize,
        }}
      />
      <Dot
        delay="0.3s"
        sx={{
          backgroundColor: color || "currentColor",
          width: dotSize,
          height: dotSize,
        }}
      />
    </Container>
  );
};

export default TypingIndicator;
